// Tintas e tons do croqui (`components/tokens.tsx`: `Ink`, `ink`, `Tone`, `toneInk`).
// O objeto `c` de lá NÃO é portado, a cor vem de `styles/tokens.css` (`spec/24` §1
// decisão 9). Aqui ficam só os dois vocabulários que os componentes do kit recebem por
// prop, traduzidos para classes do Tailwind.

/** Cor de tinta de texto/número. Os quatro níveis de `spec/17` §7 item 2 + os estados. */
export type Ink = 'text' | 'muted' | 'faint' | 'gold' | 'green' | 'danger';

export const INK_TEXT: Record<Ink, string> = {
  text: 'text-text',
  muted: 'text-muted',
  faint: 'text-faint',
  gold: 'text-gold',
  green: 'text-green',
  danger: 'text-danger',
};

export const INK_BG: Record<Ink, string> = {
  text: 'bg-text',
  muted: 'bg-muted',
  faint: 'bg-faint',
  gold: 'bg-gold',
  green: 'bg-green',
  danger: 'bg-danger',
};

/** Tom de status (Pill, Timeline, Notice). */
export type Tone = 'ok' | 'wait' | 'bad' | 'neutral' | 'info';

export const TONE_INK: Record<Tone, Ink> = {
  ok: 'green',
  wait: 'gold',
  bad: 'danger',
  neutral: 'muted',
  info: 'text',
};
